import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import styles from "./GeneralConditionL3.module.css";

import { useEffect, useState } from "react";

function GeneralConditionL3({
  distrito,
  menuFilterParams,
  searchControl,
  generalConditionValues,
  setGeneralConditionsProperties3,
}) {
  const [tipoFossa, setTipoFossa] = useState(null);
  const [descarteLixo, setDescarteLixo] = useState(null);
  const [descarteEsgoto, setDescarteEsgoto] = useState(null);
  const [tipoFossaOldValue, setTipoFossaOldValue] = useState(null);
  const [descarteLixoOldValue, setDescarteLixoOldValue] = useState(null);
  const [descarteEsgotoOldValue, setDescarteEsgotoOldValue] = useState(null);
  const [loading, setLoading] = useState(true);

  const { selectedOption, searchInput } = searchControl;
  const { category, subcategoria, natureza } = menuFilterParams;
  const {
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  } = generalConditionValues;
  const {
    setTipoFossaValue,
    setDescarteLixoValue,
    setDescarteEsgotoValue,
    setFossaImage,
    setLixoImage,
    setEsgotoImage,
  } = setGeneralConditionsProperties3;


  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [tipoFossa, descarteLixo, descarteEsgoto] = await Promise.all([
          Api.getTipoFossa(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            energiaEletricaValue,
            abastecimentoAguaValue,
            descarteLixoValue,
            descarteEsgotoValue
          ),
          Api.getDescarteLixo(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            energiaEletricaValue,
            abastecimentoAguaValue,
            tipoFossaValue,
            descarteEsgotoValue
          ),
          Api.getDescarteEsgoto(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            energiaEletricaValue,
            abastecimentoAguaValue,
            tipoFossaValue,
            descarteLixoValue
          ),
        ]);
        setTipoFossa(Functions.buildPieGraphParams2(tipoFossa));
        setDescarteLixo(Functions.buildPieGraphParams2(descarteLixo));
        setDescarteEsgoto(Functions.buildPieGraphParams2(descarteEsgoto));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  ]);

  const onTipoFossaClick = (value) => {
    setTipoFossaValue(value);
  };

  const onDescarteLixoClick = (value) => {
    setDescarteLixoValue(value);
  };

  const onDescarteEsgotoClick = (value) => {
    setDescarteEsgotoValue(value);
  };

  const onTipoFossaOldValue = (value) => {
    setTipoFossaOldValue(value);
  };

  const onDescarteLixoOldValue = (value) => {
    setDescarteLixoOldValue(value);
  };

  const onDescarteEsgotoOldValue = (value) => {
    setDescarteEsgotoOldValue(value);
  };

  if (loading) return <div className={styles.generalConditionL3}></div>;

  return (
    <div className={styles.generalConditionL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="TIPO DE FOSSA"
            data={tipoFossa}
            onLegendClick={onTipoFossaClick}
            onImageReady={setFossaImage}
            currentValue={tipoFossaValue}
            oldValue={tipoFossaOldValue}
            onOldValue={onTipoFossaOldValue}
          />
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="DESCARTE DE LIXO"
            data={descarteLixo}
            onLegendClick={onDescarteLixoClick}
            onImageReady={setLixoImage}
            currentValue={descarteLixoValue}
            oldValue={descarteLixoOldValue}
            onOldValue={onDescarteLixoOldValue}
          />
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          <PieGraph
            text="DESCARTE DE ESGOTO"
            data={descarteEsgoto}
            onLegendClick={onDescarteEsgotoClick}
            onImageReady={setEsgotoImage}
            currentValue={descarteEsgotoValue}
            oldValue={descarteEsgotoOldValue}
            onOldValue={onDescarteEsgotoOldValue}
          />
        </div>
      </div>
    </div>
  );
}

export default GeneralConditionL3;
